import * as React from "react";
import { cn } from "../lib/cn";

export interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export function EmptyState({ icon, title, description, action, className, ...props }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-charcoal-100 bg-ivory-muted/50 px-6 py-12 text-center",
        className,
      )}
      {...props}
    >
      {icon && <div className="text-charcoal-300">{icon}</div>}
      <div className="space-y-1">
        <p className="font-medium text-charcoal-800">{title}</p>
        {description && <p className="text-sm text-charcoal-500">{description}</p>}
      </div>
      {action}
    </div>
  );
}
